import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=29856f76&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29856f76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29856f76')) {
      api.createRecord('29856f76', component.options)
    } else {
      api.reload('29856f76', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=29856f76&scoped=true&", function () {
      api.rerender('29856f76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22omdsZ9bvfzf/JS/comp/Accordion.vue"
export default component.exports